import { axiosClient } from "~/common/js/axios";
import { isLoginedToken } from "~/common/js/utils";
import Cookies from "js-cookie";

import { track, SENSOR_EVENT_NAME } from "~/common/js/sensor";

import { defineStore } from "pinia";
import { useIndexStore } from "./index";

export const useIndividualStore = defineStore("individual", {
  state: () => {
    let favoritePair = null;
    if (process.client && window.localStorage.getItem("favoritePair")) {
      favoritePair = JSON.parse(window.localStorage.getItem("favoritePair"));
    } else {
      favoritePair = null;
    }
    return {
      favoritePair,
    };
  },
  actions: {
    SET_COLLECTION(data) {
      this.favoritePair = data;
    },
    DEL_COLLECTION(sid) {
      let index;
      if (!this.favoritePair) {
        index = -1;
        this.favoritePair = [];
      } else {
        index = this.favoritePair.findIndex((v) => +v.symbol_id === +sid);
      }
      if (index >= 0) {
        this.favoritePair.splice(index, 1);
      }
    },
    ADD_COLLECTION(data) {
      let index;
      if (!this.favoritePair) {
        this.favoritePair = [];
        index = -1;
      } else {
        index = this.favoritePair.findIndex(
          (v) => v.symbol_name === data.symbol_name
        );
      }
      if (index < 0) {
        this.favoritePair.push(data);
      }
    },
    async queryCollect() {
      if (!isLoginedToken()) {
        return;
      }
      
      // const token = Cookies.get("accessToken");

      const ret = await axiosClient({
        url: "/gw-api/api/v3/user_query_collection_list",
        method: "GET",
        // headers: {
        //   Authorization: token,
        // },
      });
      if (ret?.success) {
        this.SET_COLLECTION(ret.data.collection || []);
      } else {
        const localFav = window.localStorage.getItem("favoritePair");
        if (localFav) {
          this.SET_COLLECTION(JSON.parse(localFav));
        }
      }
    },
    addCollect(payload) {
      if (isLoginedToken()) {
        // const token = Cookies.get("accessToken");
        axiosClient({
          url: "/gw-api/api/v3/user_add_collection",
          method: "POST",
          // headers: {
          //   Authorization: token,
          // },
          data: {
            symbol_id: payload.symbolId,
            symbol_name: payload.symbolName,
          },
        });
      }
      // 不用等完成
      this.ADD_COLLECTION({
        symbol_id: payload.symbolId,
        symbol_name: payload.symbolName,
      });
    },
    delCollect(payload) {
      if (isLoginedToken()) {
        // const token = Cookies.get("accessToken");
        axiosClient({
          url: "/gw-api/api/v3/user_delete_collection",
          method: "POST",
          // headers: {
          //   Authorization: token,
          // },
          data: {
            symbol_id: payload.symbolId,
          },
        });
      }
      // 不用等完成
      this.DEL_COLLECTION(payload.symbolId);
    },
    triggerFav(payload) {
      let favIndex;
      if (!this.favoritePair) {
        favIndex = -1;
      } else {
        favIndex = this.favoritePair.findIndex(
          (v) => +v.symbol_id === +payload.symbolId
        );
      }

      const tradeCoinTypes = payload.sname ? payload.sname.split("/") : [];
      if (favIndex >= 0) {
        track(SENSOR_EVENT_NAME.REMOVE_FAVORITE, {
          current_page: payload.current_page,
          trade_base: tradeCoinTypes[0],
          trade_quote: tradeCoinTypes[1],
          trade_symbol: payload.sname,
        });
        // 删除
        this.delCollect({
          symbolId: payload.symbolId,
        });
      } else {
        track(SENSOR_EVENT_NAME.ADD_FAVORITE, {
          current_page: payload.current_page,
          trade_base: tradeCoinTypes[0],
          trade_quote: tradeCoinTypes[1],
          trade_symbol: payload.sname,
        });
        // 增加
        this.addCollect({
          symbolName: payload.sname,
          symbolId: payload.symbolId,
        });
      }

      const indexStore = useIndexStore()
      if (!indexStore.isLogined) {
        let localFav = window.localStorage.getItem("favoritePair");
        if (!localFav) {
          localFav = [];
        } else {
          localFav = JSON.parse(localFav);
        }
        if (favIndex >= 0) {
          // 删除
          const index = localFav.findIndex(
            (v) => +v.symbol_id === +payload.symbolId
          );
          if (index >= 0) {
            localFav.splice(index, 1);
          }
        } else {
          // 增加
          const index = localFav.findIndex(
            (v) => +v.symbol_id === +payload.symbolId
          );
          if (index < 0) {
            localFav.push({
              symbol_name: payload.sname,
              symbol_id: payload.symbolId,
            });
          }
        }
        window.localStorage.setItem("favoritePair", JSON.stringify(localFav));
      }
    },
  },
});
